import { FeaturesEnum } from './FeaturesEnum';

export type VisualFeatureKey =
  | FeaturesEnum.ateneaCustomLogin
  | FeaturesEnum.office365SSOEnabled
  | FeaturesEnum.qsCounselorTextCourseInfo
  | FeaturesEnum.qsemAccessCodeHide
  | FeaturesEnum.qsemAdvisorShowCareerTrendsScreen
  | FeaturesEnum.qsemAdvisorShowContactUsSection
  | FeaturesEnum.qsemAdvisorShowFaqSection
  | FeaturesEnum.qsemAdvisorShowSkillsInsights
  | FeaturesEnum.qsemAdvisorShowStudentAdvising
  | FeaturesEnum.qsemAdvisorShowStudentList
  | FeaturesEnum.qsemAdvisorShowStudentOverview
  | FeaturesEnum.qsemAlumniInsightsInsterest
  | FeaturesEnum.qsemDesignShowFooter
  | FeaturesEnum.qsemEnableProficiencyLevels
  | FeaturesEnum.qsemEnableProficiencyLevelsAccordions
  | FeaturesEnum.qsemFilterAcademicProgramsByStudentType
  | FeaturesEnum.qsemLearnerShowEditProfileButton
  | FeaturesEnum.qsemLearnerShowHelpSection
  | FeaturesEnum.qsemLearnerShowJobPostingRecommendations
  | FeaturesEnum.qsemLearnerShowLearningPathways
  | FeaturesEnum.qsemLpShowInfo
  | FeaturesEnum.qsemLpShowLearningPathwaysInCareerGoals
  | FeaturesEnum.qsemLpShowLearningResourceROI
  | FeaturesEnum.qsemShowCohort
  | FeaturesEnum.qsemShowOccupationComparison
  | FeaturesEnum.qsemShowSalaryComponent
  | FeaturesEnum.qsemSkillsShowCourseRecommendationsMessage
  | FeaturesEnum.qsemWizardAcademicProgramEnabled
  | FeaturesEnum.qsemWizardAddInstitutionQuestion
  | FeaturesEnum.qsemWizardEnableCareerDiscovery
  | FeaturesEnum.qsemWizardShowEmployabilityStatusQuestion
  | FeaturesEnum.qsemWizardShowHobbies
  | FeaturesEnum.qsemWizardShowInfo
  | FeaturesEnum.qsemWizardTypeOfUserQuestionEnabled
  | FeaturesEnum.qsLoginEnableRegisterUser
  | FeaturesEnum.riipenSkillsShowValidatedSkillBadge
  | FeaturesEnum.qsemProfileAssessmentHideSkillSuggestions
  | FeaturesEnum.qsemAcademicProgramsFacultyFilter
  | FeaturesEnum.qsemAlternatePlarWizard;

export const VISUAL_FEATURE_KEYS: VisualFeatureKey[] = [
  FeaturesEnum.ateneaCustomLogin,
  FeaturesEnum.office365SSOEnabled,
  FeaturesEnum.qsCounselorTextCourseInfo,
  FeaturesEnum.qsemAccessCodeHide,
  FeaturesEnum.qsemAdvisorShowCareerTrendsScreen,
  FeaturesEnum.qsemAdvisorShowContactUsSection,
  FeaturesEnum.qsemAdvisorShowFaqSection,
  FeaturesEnum.qsemAdvisorShowSkillsInsights,
  FeaturesEnum.qsemAdvisorShowStudentAdvising,
  FeaturesEnum.qsemAdvisorShowStudentList,
  FeaturesEnum.qsemAdvisorShowStudentOverview,
  FeaturesEnum.qsemAlumniInsightsInsterest,
  FeaturesEnum.qsemDesignShowFooter,
  FeaturesEnum.qsemEnableProficiencyLevels,
  FeaturesEnum.qsemEnableProficiencyLevelsAccordions,
  FeaturesEnum.qsemFilterAcademicProgramsByStudentType,
  FeaturesEnum.qsemLearnerShowEditProfileButton,
  FeaturesEnum.qsemLearnerShowHelpSection,
  FeaturesEnum.qsemLearnerShowJobPostingRecommendations,
  FeaturesEnum.qsemLearnerShowLearningPathways,
  FeaturesEnum.qsemLpShowInfo,
  FeaturesEnum.qsemLpShowLearningPathwaysInCareerGoals,
  FeaturesEnum.qsemLpShowLearningResourceROI,
  FeaturesEnum.qsemShowCohort,
  FeaturesEnum.qsemShowOccupationComparison,
  FeaturesEnum.qsemShowSalaryComponent,
  FeaturesEnum.qsemSkillsShowCourseRecommendationsMessage,
  FeaturesEnum.qsemWizardAcademicProgramEnabled,
  FeaturesEnum.qsemWizardAddInstitutionQuestion,
  FeaturesEnum.qsemWizardEnableCareerDiscovery,
  FeaturesEnum.qsemWizardShowEmployabilityStatusQuestion,
  FeaturesEnum.qsemWizardShowHobbies,
  FeaturesEnum.qsemWizardShowInfo,
  FeaturesEnum.qsemWizardTypeOfUserQuestionEnabled,
  FeaturesEnum.qsLoginEnableRegisterUser,
  FeaturesEnum.riipenSkillsShowValidatedSkillBadge,
  FeaturesEnum.qsemAcademicProgramsFacultyFilter,
  FeaturesEnum.qsemAlternatePlarWizard,
  FeaturesEnum.qsemProfileAssessmentHideSkillSuggestions,
  FeaturesEnum.qsemAlternatePlarWizard,
];
